// constants.js
export const callFromAppTriggerEndPoint = `${process.env.REACT_APP_FUNCTIONS_URL}/callFromAppTrigger?code=${process.env.REACT_APP_CALL_FROM_APP_FUNCTION_KEY}`;
export const saveConfigFunctionEndpoint = `${process.env.REACT_APP_FUNCTIONS_URL}/saveConfigFunction?code=${process.env.REACT_APP_SAVE_CONFIG_FUNCTION_KEY}`;
export const getConfigFunctionEndpoint = `${process.env.REACT_APP_FUNCTIONS_URL}/getConfigFunction?code=${process.env.REACT_APP_GET_CONFIG_FUNCTION_KEY}`;
export const sendMessageFunctionEndpoint = `${process.env.REACT_APP_FUNCTIONS_URL}/sendMessageFunction?code=${process.env.REACT_APP_SEND_MESSAGE_FUNCTION_KEY}`;

export const SUMMARIZE_CONFIG = {
  "name": "Summarizer",
  "role": "Summarizer",
  "systemMessage": "You are a negotiator that helps people summarize their situations and advice they've received from other consultants.",
  "assistantMessage": "Read the user's situation below and also read previous advice they've been given. Take into consideration all the advice and summarize it in a way that is easy to understand. Limit your response length unless necessary to get the point across to the person.",
  "temperature": 0.5,
  "top_p": 0.99,
  "max_tokens": 1000
};

export const TableName = 'UserConfigs';
export const StorageAccountURL = 'https://aiconsultantstorage2.table.core.windows.net/UserConfigs';

export const DefaultUserInput = `I’m starting a new business and need guidance on product-market fit, team building, and how to pitch to investors.`;

export const Widths = {
  WIDTH_100: '100px',
  WIDTH_200: '200px',
  WIDTH_300: '300px',
  WIDTH_400: '400px',
  WIDTH_500: '500px',
  WIDTH_600: '600px',
  WIDTH_700: '700px',
  WIDTH_800: '800px',
  WIDTH_900: '900px',
  WIDTH_1000: '1000px',
  WIDTH_1100: '1100px',
  WIDTH_1200: '1200px',
  WIDTH_1300: '1300px',
  WIDTH_1400: '1400px',
  WIDTH_1500: '1500px',
};


export const BOXWIDTH = Widths.WIDTH_500;

export const MOBILE_BREAKPOINT = 600;
